<template>
  <div class="overlay">

    <div class="weight-modal">
      <button class="close mt-2 mr-2 bg-light">
        <b-icon-x @click="$emit('close')" />
      </button>

      <div class="full-container mt-2 content-hidden" :class="{ 'content-show': !showSecondPopup }">
        <div class="full-column">

          <div class="my-4">
            <h4 class="fs12">Gewicht aktualisieren</h4>
          </div>
          <div class="">
            <p v-if="pet.bcs > 3">Laut unseren Informationen soll {{pet.name}} abnehmen. Bitte geben Sie das aktuelle Gewicht an:</p>
            <p v-if="pet.bcs < 3">Laut unseren Informationen soll {{pet.name}} zunehmen. Geben Sie bitte das aktuelle Gewicht an:</p>
            <p v-if="pet.isPuppy">Da sich {{pet.name}} im Wachstum befindet, ändert sich der Bedarf an das Futter ständig. Bitte geben Sie hier das aktuelle Gewicht an:</p>
          </div>

          <div class="full-column mt-4">
            <div class="narrow-column">
              <div class="d-block clearfix float-left onehalf">
                <div class="onehalf">
                  <input type="text" v-model="Current" style="padding:10px;width:100%;border:1px solid lightgray" v-bind:style="{'border-color': showRequired||WeightValidation ? 'red' : 'lightgray'}" />
                  <p v-if="showRequired" style="color:red">Gewicht ist erforderlich</p>
                  <div class="validation-advice" v-if="WeightValidation">Der Wert ist nicht innerhalb des erlaubten Bereichs.</div>
                </div>
                <div class="onehalf pl-0 aligntext">kg</div>
              </div>

              <div class="d-flex float-left onehalf" style="align-items:center;height:46px">
                <div class="pl-0">(Letztes Gewicht: {{pet.weight}} kg)</div>
              </div>

              <div style="clear:both"></div>
            </div>
          </div>

          <div class="my-4">
            <p v-if="pet.bcs > 3">Falls {{pet.name}} noch nicht abgenommen hat, werden unsere Tierärzte die Ration anpassen.</p>
            <p v-if="pet.bcs < 3">Falls {{pet.name}} noch nicht zugenommen hat, werden unsere Tierärzte die Ration anpassen.</p>
            <p v-if="pet.isPuppy">So können wir eine neue, optimierte Ration für {{pet.name}} berechnen.</p>
          </div>

          <!-- check if we can show next popup -->
          <button class="futalis-btn futalis-button-green btn-block mb-4" @click="checkContinue">Weiter</button>

        </div>
      </div>


      <div class="full-container mt-2 content-hidden" :class="{ 'content-show': showSecondPopup }">
        <div class="full-column">

          <div class="my-4">
            <h4 class="fs12">Toll, es sieht aus, als hätte {{pet.name}} Idealgewicht erreicht!</h4>
          </div>
          <p>{{pet.name}} hat noch kein Idealgewicht? Dann passen Sie bitte Ernährungszustand und Zielgewicht an:</p>

          <div style="text-align:center" class="mt-4">
            <div>Ernährungszustand</div>
            <div class="bcs-container mb-4">
              <a href="javascript:void(0)" class="text-decoration-none " data-toggle="collapse" v-on:click="collapseBcs = !collapseBcs">
                <b-icon-chevron-down class="chevron-down-icon" />
                <div class="bcs-card">
                  <h4 class="card-title" style="margin:0;text-transform:none;font-size:19px">{{ BcsList[Bcs] }}</h4>
                </div>
              </a>
              <div class="bcs-content collapse" v-bind:class="{ 'show': collapseBcs == false }">
                  <a href="javascript:void(0)"
                     class="bcs-card"
                     v-for="bcsId in Object.keys(BcsList)"
                     v-on:click="onBcsClick(bcsId)">
                    {{ BcsList[bcsId] }}
                  </a>
              </div>
            </div>

            <div>Zielgewicht in kg</div>
            <input type="text" v-model="Target" style="padding:10px;text-align:center" />
            <p class="mb-4">(Aktuelles Gewicht: {{Current}} kg)</p>
          </div>

          <!-- go to step6 -->
          <button class="futalis-btn futalis-button-green btn-block mb-4" @click="recalculate()">Weiter zur Bestellung</button>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import router from "@/modules/router/config";
import Vue from "vue";
import {CONSTANTS} from "@/constants/guide";

export default {
  name: 'WeightPopup',
  props: ['pet'],
  data() {
    return {
      showSecondPopup: false,
      collapseBcs: true,
      showRequired: false,

      WeightValidation: false,

      Current: null,
      Target: null,
      Bcs: 3,
      BcsList: {
        '1': '(BCS 1) stark untergewichtig',
        '2': '(BCS 2) leicht untergewichtig',
        '3': '(BCS 3) Normal',
        '4': '(BCS 4) leicht übergewichtig',
        '5': '(BCS 5) stark übergewichtig'
      }
    };
  },
  methods: {
    checkContinue: function() {
      if (!this.Current || this.Current <= 0) {
        this.showRequired = true;
        return;
      }
      if (this.pet.isPuppy) {
        this.savePetWeight(1); // store new pet weight and recalculate
        return;
      }
      var currentWeight = parseFloat(this.Current.replace(',', '.'));
      if (this.pet.bcs < 3) {
        if (currentWeight >= parseFloat(this.pet.targetWeight) * 0.99) {
          this.showSecondPopup = true;
        }
      }
      if (this.pet.bcs > 3) {
        if (currentWeight <= parseFloat(this.pet.targetWeight) * 1.01) {
          this.showSecondPopup = true;
        }
      }
      if (this.showSecondPopup) {
        this.Target = this.Current;
        this.Bcs = this.pet.bcs;
      } else {
        this.Target = this.pet.targetWeight;
        this.Bcs = this.pet.bcs;
        this.savePetWeight(0); // store new pet weight and reorder
      }
    },
    onBcsClick: function(bcsId) {
      this.Bcs = bcsId;
      this.collapseBcs = true;
    },
    recalculate: function() {
      this.savePetWeight(1); // store new pet weight and recalculate
    },
    savePetWeight: function(recalculate) {
      if (this.Current > 160 || this.Current <= 0) {
        this.WeightValidation = true;
        return;
      }

      if (this.pet.isPuppy) {
        this.Target = this.Current;
        this.Bcs = 3;
      }

      if (parseFloat(this.Current.replace(',', '.')) == parseFloat(this.pet.weight.toString().replace(',', '.'))) { // if weight didn't change just proceed
        this.$emit('close');
        Vue.swal.close();

        if (recalculate) {
          this.$emit('recalculate');
        } else {
          this.$emit('reorder');
        }
        return;
      }

      this.showLoadingDialogOnSave();
      const breed = {
        id: this.pet.breedId,
        name: this.pet.breedName,
        nameId: this.pet.breedNameId,
      };
      const petData = {
        ...this.pet,
        weight: this.Current,
        targetWeight: this.Target,
        bcs: this.Bcs,
        allergies: Object.keys(this.pet.allergies),
        additives: Object.keys(this.pet.additives),
        illnesses: Object.keys(this.pet.illnesses),
        breed: breed
      };
      delete petData.image;

      this.$store
          .dispatch('configuratorModule/savePet', {
            id: this.pet.id,
            petData,
            mode: CONSTANTS.CONFIGURATOR.MODES.EDIT_PET
          })
          .then(promise => {
           Vue.swal.close();
            if (typeof promise == 'undefined') {
              alert('Error while saving the pet');
              return;
            }
            this.$emit('close');

            if (recalculate) {
              this.$emit('recalculate');
            } else {
              this.$emit('reorder');
            }
          });

    },
    showLoadingDialogOnSave() {
      this.$swal({
        title: 'Ihre Daten wurden gespeichert',
        showCancelButton: false,
        showConfirmButton: false,
        customClass: {
          title: 'configurator-confirm-title-alert'
        },
        didOpen: Vue.swal.showLoading(),
        allowOutsideClick: () => false,
        allowEscapeKey: () => false,
        allowEnterKey: () => false
      });
    },
  },
};
</script>

<style scoped>
.weight-modal {
  width: 750px;
  height: auto;
  background-color: #ffffff;
  position: fixed;
  font-size: 1rem;
  margin-left: -350px;
  top: 15%;
  left: 50%;
  color: #777;
  border-radius: 5px;
}
.content-hidden {
  display: none;
}
.content-show {
  display: block !important;
}
.narrow-column {
  padding: 0 10%;
  width: 100%;
}
.bcs-content {
  position: absolute;
  box-shadow: rgba(0,0,0,0.2) 5px 5px 20px;
  width: 100%;
  top: 0;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background-color: white;
}
.bcs-card {
  font-size: 1rem;
  margin: auto;
  padding: 20px;
  background-color: white;
  display: block;
  color: #666;
}
.bcs-card:hover {
  background-color: rgba(186, 207, 0, 0.5);
  text-decoration: none;
}
.bcs-container {
  position: relative;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.chevron-down-icon {
  position: absolute;
  right: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  margin: 20px 20px 0 0;
}

.onehalf {
  width: 50%;
  float: left;
  padding: 0 5% 0 0;
}
.aligntext {
  padding-top: 9px !important;
}
.full-column {
  display: block;
  width: 100%;
}
.full-container {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (max-width: 768px) {
  .weight-modal {
    width: 100vw;
    left: 0;
    margin: 0;
    top: 90px !important;
    font-size: 0.9rem;
    position: absolute;
    border-radius: 0;
  }
  h4.fs12 {
    font-size: 1.2rem !important;
  }
  .full-container {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .overlay {
    display: block;
    max-height: 1000000px;
    max-width: 1000000px;
    overflow: scroll;
  }
}
</style>
